import type { ReactNode } from 'react';

/**
 * A titled section of a page: the small-caps head over a rule, then its body
 * (`.section`, styles/sections.css). `lead` is the research reading's larger
 * head, the `.cat-head` treatment the brief's own blocks open with.
 */
export function Section({
  title,
  lead = false,
  children,
}: {
  title: ReactNode;
  lead?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="section">
      <h2>{lead ? <span className="cat-head static lead">{title}</span> : title}</h2>
      {children}
    </div>
  );
}
